import * as angular from "angular";
import {
	FormUiSchema,
	generatedObjectUiSchema
} from "../runtime";
import type { ControlState } from "./control-state";
import template from "./object-control.html";

export interface ObjectControlController {
	control: ControlState;
}

// AngularJS owns the merged binding properties.
// eslint-disable-next-line no-redeclare
export class ObjectControlController implements angular.IController {
	public children?: FormUiSchema;

	public $onChanges(): void {
		this.children = this.control.ui.options?.detail
			?? generatedObjectUiSchema(this.control.schema, this.control.session.runtime.schema);
	}
}

export default angular.module("vesl.extensions.json-schema.object-control", [])
	.component("jsonSchemaObjectControl", {
		template,
		controller: ObjectControlController,
		bindings: { control: "<" }
	})
	.name;
